import React from "react";
import "./footer.css";

function Footer() {
  return (
    <section className="container footer_container">
      <div className="footer_text">
        <div>
          <div
            style={{
              marginBottom: "1rem",
            }}
          >
            <a href="https://t.me/MonkeyDoo_NFT" target="_blank">
              <i
                className="fa fa-telegram"
                style={{
                  color: "#fff",
                  fontSize: "35px",
                  margin: "5px",
                }}
              ></i>
            </a>
            <a
              href="https://twitter.com/MonkeyDoo_NFT?t=YtUCLKwoeuqsy5GUxIxxtQ&s=09"
              target="_blank"
            >
              <i
                className="fa fa-twitter"
                style={{
                  color: "#fff",
                  fontSize: "35px",
                  margin: "5px",
                }}
              ></i>
            </a>
            <a href="https://discord.gg/UhZFZHYwNx" target="_blank">
              <i
                className="fa fa-discord"
                style={{
                  color: "#fff",
                  fontSize: "35px",
                  margin: "5px",
                }}
              ></i>
            </a>
          </div>
        </div>
        <h5>
          <small> copyright &copy; 2022 </small>
        </h5>
        <h3>All rights reserved.</h3>
      </div>
    </section>
  );
}

export default Footer;
